import { SupportedLanguage } from '@rms/env';

export const DEFAULT_LANGUAGE: SupportedLanguage = {
  name: 'English',
  locale: 'en',
};
